module.exports = __webpack_public_path__ + "media/images/vp/icon.in.red-d2eece6e1efe0c22764f765a865e172f.png";